// Portal styles - injected into document head for dialogs in light DOM
// This file is auto-generated by buildStyles.js - DO NOT EDIT MANUALLY
export const portalStyles = `
/* Portal styles - for dialogs in light DOM */
/* These need !important to protect from host page CSS */

/* Portal container */
[data-abba-portal] {
  isolation: isolate !important;
  font-family: ui-sans-serif, system-ui, sans-serif !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  -webkit-font-smoothing: antialiased !important;
}

/* ===== REKA UI DIALOG STYLES ===== */
/* These styles target reka-ui dialog elements that portal to body */

/* Dialog overlay - reka-ui uses data-slot="dialog-overlay" */
[data-slot="dialog-overlay"] {
  position: fixed !important;
  inset: 0 !important;
  z-index: 2147483646 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  animation: fadeIn 0.15s ease-out !important;
}

/* Dialog content - reka-ui uses data-slot="dialog-content" */
[data-slot="dialog-content"] {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  z-index: 2147483647 !important;
  background-color: white !important;
  border-radius: 12px !important;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2) !important;
  max-width: 600px !important;
  width: calc(100vw - 32px) !important;
  max-height: 85vh !important;
  overflow-y: auto !important;
  animation: dialogIn 0.2s ease-out !important;
  padding: 24px !important;
  font-family: ui-sans-serif, system-ui, sans-serif !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: hsl(222.2 84% 4.9%) !important;
  border: 1px solid hsl(214.3 31.8% 91.4%) !important;
}

/* Dialog close button */
[data-slot="dialog-close"] {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  background: transparent !important;
  border: none !important;
  padding: 4px !important;
  cursor: pointer !important;
  opacity: 0.7 !important;
  transition: opacity 0.15s !important;
  color: hsl(222.2 84% 4.9%) !important;
}

[data-slot="dialog-close"]:hover {
  opacity: 1 !important;
}

/* Screen reader only text in close button */
[data-slot="dialog-close"] .sr-only,
[data-slot="dialog-close"] span:not(:has(svg)) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

/* Dialog header */
[data-slot="dialog-content"] h2,
[data-slot="dialog-content"] [data-slot="dialog-title"] {
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;
  margin: 0 0 8px 0 !important;
  padding-right: 32px !important;  /* Space for close button */
  color: hsl(222.2 84% 4.9%) !important;
}

[data-slot="dialog-content"] [data-slot="dialog-description"] {
  font-size: 15px !important;
  line-height: 1.6 !important;
  color: hsl(215.4 16.3% 46.9%) !important;
  margin: 0 0 16px 0 !important;
}

/* Guide dialog specific styles */
.abba-guide-dialog {
  width: min(1120px, calc(100vw - 64px)) !important;
  max-width: min(1120px, calc(100vw - 64px)) !important;
  max-height: min(1240px, calc(100vh - 64px)) !important;
  padding: 28px 30px 26px !important;
  border-radius: 20px !important;
  border: 1px solid #d9e1ea !important;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18) !important;
  gap: 0 !important;
  overflow: hidden !important;
  background: #ffffff !important;
}

.abba-guide-dialog [data-slot="dialog-close"] {
  top: 30px !important;
  right: 28px !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  border-radius: 8px !important;
  background: transparent !important;
  color: #4b5563 !important;
  opacity: 1 !important;
}

.abba-guide-dialog [data-slot="dialog-close"]:hover {
  background: #f3f7fb !important;
  color: #1f2937 !important;
}

.abba-guide-header {
  padding-right: 56px !important;
  margin-bottom: 26px !important;
}

.abba-guide-dialog [data-slot="dialog-title"] {
  font-size: 22px !important;
  line-height: 1.15 !important;
  font-weight: 500 !important;
  letter-spacing: -0.03em !important;
  color: #1f2937 !important;
  margin: 0 0 8px 0 !important;
  padding-right: 0 !important;
}

.abba-guide-dialog [data-slot="dialog-description"] {
  font-size: 14px !important;
  line-height: 1.45 !important;
  color: #4b5563 !important;
  margin: 0 !important;
}

.abba-guide-body {
  display: flex !important;
  flex-direction: column !important;
  gap: 18px !important;
  overflow-y: auto !important;
  padding-right: 4px !important;
}

.abba-guide-body::-webkit-scrollbar {
  width: 8px !important;
}

.abba-guide-body::-webkit-scrollbar-thumb {
  background: #d7dee7 !important;
  border-radius: 999px !important;
}

.abba-guide-step {
  display: grid !important;
  grid-template-columns: 88px minmax(0, 1fr) !important;
  gap: 24px !important;
  align-items: start !important;
  padding: 22px 28px !important;
  border: 1px solid #dbe4ed !important;
  border-radius: 22px !important;
  background: #f7fafc !important;
}

.abba-guide-step-number {
  font-family: ui-monospace, "SF Mono", Menlo, monospace !important;
  font-size: 16px !important;
  line-height: 1 !important;
  color: #8b97a6 !important;
  padding-top: 6px !important;
}

.abba-guide-step-copy h3 {
  margin: 0 0 10px 0 !important;
  font-size: 22px !important;
  line-height: 1.15 !important;
  letter-spacing: -0.03em !important;
  font-weight: 500 !important;
  color: #1f2937 !important;
}

.abba-guide-step-copy p {
  margin: 0 !important;
  font-size: 14px !important;
  line-height: 1.45 !important;
  color: #4b5563 !important;
  max-width: 48ch !important;
}

.abba-guide-footer {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 16px !important;
  margin-top: 28px !important;
}

.abba-guide-esc {
  font-size: 14px !important;
  line-height: 1.3 !important;
  color: #7b8794 !important;
}

.abba-guide-esc span {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: 44px !important;
  height: 36px !important;
  margin: 0 4px !important;
  padding: 0 12px !important;
  border-radius: 10px !important;
  border: 1px solid #d7dee7 !important;
  background: #ffffff !important;
  font-family: ui-monospace, "SF Mono", Menlo, monospace !important;
  font-size: 14px !important;
  color: #7b8794 !important;
}

.abba-guide-cta {
  height: 62px !important;
  padding: 0 28px !important;
  border-radius: 18px !important;
  background: #1f2937 !important;
  color: #ffffff !important;
  border: 0 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  letter-spacing: -0.02em !important;
}

.abba-guide-cta:hover {
  background: #111827 !important;
}

@media (max-width: 900px) {
  .abba-guide-dialog {
    width: calc(100vw - 24px) !important;
    max-width: calc(100vw - 24px) !important;
    max-height: calc(100vh - 24px) !important;
    padding: 22px 20px 20px !important;
  }

  .abba-guide-header {
    margin-bottom: 20px !important;
  }

  .abba-guide-dialog [data-slot="dialog-title"] {
    font-size: 20px !important;
  }

  .abba-guide-dialog [data-slot="dialog-description"] {
    font-size: 13px !important;
  }

  .abba-guide-step {
    grid-template-columns: 1fr !important;
    gap: 14px !important;
    padding: 18px 18px 20px !important;
    border-radius: 18px !important;
  }

  .abba-guide-step-number {
    font-size: 18px !important;
    padding-top: 0 !important;
  }

  .abba-guide-step-copy h3 {
    font-size: 18px !important;
  }

  .abba-guide-step-copy p {
    font-size: 13px !important;
    max-width: none !important;
  }

  .abba-guide-footer {
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .abba-guide-cta {
    width: 100% !important;
    height: 54px !important;
    font-size: 15px !important;
  }
}

/* Legacy radix dialog styles - keep for compatibility */
/* Dialog overlay */
[data-abba-portal] [data-radix-dialog-overlay],
[data-abba-portal] div[data-state="open"][role="presentation"] {
  position: fixed !important;
  inset: 0 !important;
  z-index: 2147483646 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  animation: fadeIn 0.15s ease-out !important;
}

/* Dialog content */
[data-abba-portal] [data-radix-dialog-content],
[data-abba-portal] div[role="dialog"][data-state="open"] {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  z-index: 2147483647 !important;
  background-color: white !important;
  border-radius: 12px !important;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2) !important;
  max-width: 500px !important;
  width: calc(100vw - 32px) !important;
  max-height: 85vh !important;
  overflow-y: auto !important;
  animation: dialogIn 0.2s ease-out !important;
}

/* Dialog animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes dialogIn {
  from { opacity: 0; transform: translate(-50%, -48%) scale(0.96); }
  to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
}

/* Dialog close button */
[data-abba-portal] button[data-radix-dialog-close] {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  background: transparent !important;
  border: none !important;
  padding: 4px !important;
  cursor: pointer !important;
  opacity: 0.7 !important;
  transition: opacity 0.15s !important;
}

[data-abba-portal] button[data-radix-dialog-close]:hover {
  opacity: 1 !important;
}

/* Typography protection */
[data-abba-portal] h1, [data-abba-portal] h2, [data-abba-portal] h3 {
  color: hsl(222.2 84% 4.9%) !important;
  font-weight: 600 !important;
  margin: 0 !important;
}

[data-abba-portal] p {
  color: hsl(215.4 16.3% 46.9%) !important;
  margin: 0 !important;
}

/* Tooltip styles - global selector for tooltips that portal to body */
/* Supports both Reka UI (Vue) and Radix (if used) */

/* ABBA BETA tooltip - specific styling for the BETA badge tooltip */
.abba-beta-tooltip {
  background-color: hsl(222.2 84% 4.9%) !important;
  color: white !important;
  padding: 8px 12px !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  z-index: 2147483647 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  font-family: ui-sans-serif, system-ui, sans-serif !important;
  line-height: 1.5 !important;
  max-width: 300px !important;
}

.abba-beta-tooltip p,
.abba-beta-tooltip .text-sm {
  color: white !important;
  margin: 0 !important;
}

/* Reka UI tooltip content - targets elements with reka-tooltip in ID */
[id^="reka-tooltip-content"],
[role="tooltip"] {
  background-color: hsl(222.2 84% 4.9%) !important;
  color: white !important;
  padding: 8px 12px !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  z-index: 2147483647 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  font-family: ui-sans-serif, system-ui, sans-serif !important;
  line-height: 1.5 !important;
  max-width: 300px !important;
  width: auto !important;
  height: auto !important;
  overflow: visible !important;
  white-space: normal !important;
}

/* Reka UI popper wrapper */
[id^="reka-popper-content"] {
  z-index: 2147483647 !important;
}

/* Radix tooltip styles (keep for compatibility) */
[data-radix-popper-content-wrapper] {
  z-index: 2147483647 !important;
}

[data-radix-tooltip-content] {
  background-color: hsl(222.2 84% 4.9%) !important;
  color: white !important;
  padding: 8px 12px !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  z-index: 2147483647 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  font-family: ui-sans-serif, system-ui, sans-serif !important;
  line-height: 1.5 !important;
  max-width: 300px !important;
}

/* Portal pointer events */
[data-abba-portal] > div[data-radix-portal] {
  position: fixed !important;
  z-index: 2147483646 !important;
  pointer-events: none !important;
}

[data-abba-portal] > div[data-radix-portal] > * {
  pointer-events: auto !important;
}

`